// Lokal quittierte Auth-Epoch für den einmaligen Zwangs-Logout (ADR-002,
// Lazy-Migration-Beschleuniger). Der Server meldet seine Epoch über
// GET /api/auth/config; ist sie neuer als die hier gespeicherte, loggt der
// Client die bestehende Session einmalig aus (s. enforceAuthEpoch in
// auth.duck.js). 0 = noch nie quittiert.

const KEY = 'vansite-auth-epoch';

export const getStoredAuthEpoch = () => {
  if (typeof window === 'undefined') return 0;
  const raw = window.localStorage.getItem(KEY);
  const parsed = raw ? Number.parseInt(raw, 10) : 0;
  return Number.isInteger(parsed) && parsed > 0 ? parsed : 0;
};

export const setStoredAuthEpoch = epoch => {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(KEY, String(epoch));
};
